import React, { useState } from "react";
import MyReviewsStars from "src/components/shared/MyReviewsStars";

export const CourseReviewCard: React.FC<{
  courseReview: any;
  deleteReview: (reviewId: string) => void;
}> = ({ courseReview, deleteReview }) => {
  const [isImageLoaded, setIsImageLoaded] = useState<Boolean>(false);
  const [isDeleteButtonClicked, setIsDeleteButtonClicked] =
    useState<Boolean>(false);
  return (
    <div className="relative flex justify-start items-start space-x-[28px] w-full rounded-[14px] border-[1px] border-[#F5F5F5] p-[10px]">
      {/* courseReview image */}
      <div className="relative w-[288px] h-[182px] overflow-hidden rounded-[8px] bg-gray-300 flex justify-center items-center">
        {!isImageLoaded && (
          <div className="absolute inset-0 bg-gray-300 animate-pulse"></div>
        )}
        {!isImageLoaded && (
          <div className="absolute inset-0 flex justify-center items-center">
            <span className="animate-spin rounded-full h-6 w-6 border-t-2 border-white"></span>
          </div>
        )}
        <img
          src={courseReview.courseImage}
          alt={courseReview.courseName}
          className={`w-full h-full object-cover transition-opacity duration-500 ${
            isImageLoaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setIsImageLoaded(true)}
          loading="lazy"
        />
      </div>
      {/* courseReview content */}
      <div className="w-full max-w-[500px] flex flex-col justify-start items-start space-y-[12px]">
        {/* courseReview title & rating */}
        <div className="flex flex-col justify-start items-start space-y-[6px]">
          {/* title & delete button */}
          <span className="text-[#0F0220] font-inter font-semibold text-[22px] leading-[32px] ">
            {courseReview.courseName}
          </span>
          {/* rating stars */}
          <MyReviewsStars rating={courseReview.rating}></MyReviewsStars>
        </div>
        {/* courseReview review title & content */}
        <div className="flex flex-col justify-start items-start space-y-[2px]">
          <span className="text-[#1E1E1E] font-inter font-bold text-[16px] leading-[25px]">
            {courseReview.title}
          </span>
          <span className="text-[#1F1F1F] font-inter font-normal text-[14px] leading-[24px] opacity-90">
            {courseReview.content}
          </span>
        </div>
      </div>
      {/* open delete review button */}
      <button
        type="button"
        className="absolute top-[12px] right-[8px]"
        onClick={() => {
          setIsDeleteButtonClicked(!isDeleteButtonClicked);
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z"
            fill="#0D0D0D"
            stroke="#0D0D0D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 18.5C12.2761 18.5 12.5 18.2761 12.5 18C12.5 17.7239 12.2761 17.5 12 17.5C11.7239 17.5 11.5 17.7239 11.5 18C11.5 18.2761 11.7239 18.5 12 18.5Z"
            fill="#0D0D0D"
            stroke="#0D0D0D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 6.5C12.2761 6.5 12.5 6.27614 12.5 6C12.5 5.72386 12.2761 5.5 12 5.5C11.7239 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.7239 6.5 12 6.5Z"
            fill="#0D0D0D"
            stroke="#0D0D0D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {/* delete course review from list button */}
      {isDeleteButtonClicked && (
        <button
          className="absolute top-[55px] right-[3px] w-[201px] h-[56px] rounded-[12px] px-[20px] py-[8px] bg-white shadow-lg text-start"
          onClick={() => deleteReview(courseReview.id)}
        >
          <span className=" text-[#D22121] font-inter font-normal text-[14px] leading-[24px] text-start ">
            Delete Review
          </span>
        </button>
      )}
    </div>
  );
};

export const CourseReviewSkeleton: React.FC = () => {
  return (
    <div className="flex justify-start items-start space-x-[28px] w-full rounded-[14px] border-[1px] border-[#F5F5F5] p-[10px]">
      <div className="w-[288px] h-[182px] bg-gray-300 rounded-[8px] animate-pulse"></div>

      <div className="w-full max-w-[500px] flex flex-col justify-start items-start space-y-[12px]">
        <div className="w-full flex flex-col justify-start items-start space-y-[6px]">
          <div className="w-[80%] h-[22px] bg-gray-300 rounded-md animate-pulse"></div>
          <div className="w-[60%] h-[16px] bg-gray-300 rounded-md animate-pulse"></div>
        </div>

        <div className="w-full flex flex-col justify-start items-start space-y-[4px]">
          <div className="w-[50%] h-[16px] bg-gray-300 rounded-md animate-pulse"></div>
          <div className="w-[90%] h-[14px] bg-gray-300 rounded-md animate-pulse"></div>
          <div className="w-[85%] h-[14px] bg-gray-300 rounded-md animate-pulse"></div>
          <div className="w-[80%] h-[14px] bg-gray-300 rounded-md animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export const CourseReviewCardMobile: React.FC<{
  courseReview: any;
  deleteReview: (reviewId: string) => void;
}> = ({ courseReview, deleteReview }) => {
  const [isImageLoaded, setIsImageLoaded] = useState<Boolean>(false);
  const [isDeleteButtonClicked, setIsDeleteButtonClicked] =
    useState<Boolean>(false);
  return (
    <div className="relative flex flex-col justify-start items-start space-y-[10px] w-full rounded-[14px] border-[1px] border-[#F5F5F5] p-[6px]">
      {/* courseReview image & title */}
      <div className="w-full flex justify-start items-start space-x-[8px]">
        {/* courseReview image */}
        <div className="relative w-[89.33px] h-[56px] overflow-hidden rounded-[6px] bg-gray-300 flex justify-center items-center">
          {!isImageLoaded && (
            <div className="absolute inset-0 bg-gray-300 animate-pulse"></div>
          )}
          {!isImageLoaded && (
            <div className="absolute inset-0 flex justify-center items-center">
              <span className="animate-spin rounded-full h-6 w-6 border-t-2 border-white"></span>
            </div>
          )}
          <img
            src={courseReview.courseImage}
            alt={courseReview.courseName}
            className={`w-full h-full object-cover transition-opacity duration-500 ${
              isImageLoaded ? "opacity-100" : "opacity-0"
            }`}
            onLoad={() => setIsImageLoaded(true)}
            loading="lazy"
          />
        </div>
        {/* courseReview title */}
        <span className="text-[#1B0209] font-inter font-bold text-[16px] leading-[25px] line-clamp-2 max-w-[180px]">
          {courseReview.courseName}
        </span>
      </div>

      {/* courseReview stars */}
      <MyReviewsStars rating={courseReview.rating}></MyReviewsStars>

      {/* courseReview content */}
      <div className="w-full flex flex-col justify-start items-start space-y-[2px]">
        <span className="text-[#1E1E1E] font-inter font-bold text-[16px] leading-[25px]">
          {courseReview.title}
        </span>
        <span className="text-[#1F1F1F] font-inter font-normal text-[14px] leading-[24px] opacity-90 ">
          {courseReview.content}
        </span>
      </div>
      {/* open delete review button */}
      <button
        type="button"
        className="absolute top-[12px] right-[8px]"
        onClick={() => {
          setIsDeleteButtonClicked(!isDeleteButtonClicked);
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z"
            fill="#0D0D0D"
            stroke="#0D0D0D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 18.5C12.2761 18.5 12.5 18.2761 12.5 18C12.5 17.7239 12.2761 17.5 12 17.5C11.7239 17.5 11.5 17.7239 11.5 18C11.5 18.2761 11.7239 18.5 12 18.5Z"
            fill="#0D0D0D"
            stroke="#0D0D0D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 6.5C12.2761 6.5 12.5 6.27614 12.5 6C12.5 5.72386 12.2761 5.5 12 5.5C11.7239 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.7239 6.5 12 6.5Z"
            fill="#0D0D0D"
            stroke="#0D0D0D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {/* delete course review from list button */}
      {isDeleteButtonClicked && (
        <button
          className="absolute top-[55px] right-[3px] w-[201px] h-[56px] rounded-[12px] px-[20px] py-[8px] bg-white shadow-lg text-start"
          onClick={() => deleteReview(courseReview.id)}
        >
          <span className=" text-[#D22121] font-inter font-normal text-[14px] leading-[24px] text-start ">
            Delete Review
          </span>
        </button>
      )}
    </div>
  );
};
